<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/planos">Planos</router-link>
          </li>
          <li class="breadcrumb-item active">Criar Plano</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{ erroMensagem }}</span>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Plano
            </h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome <b>*Obrigatório</b></label>
                <input type="text" class="form-control" placeholder="Informe o nome do plano" v-model="plano.name">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Código ANS <b>*Obrigatório</b></label>
                <input type="text" class="form-control" placeholder="Informe o código ANS" v-model="plano.ans">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Foto do plano</label>
                <input type="file" class="form-control" placeholder="Informe a foto" @change="trocaFoto" />
              </div>
              <img :src="imagem_foto" class="img-thumbnail" v-if="imagem_foto" />
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Pessoa</label>
                <select class="form-control" @change="e => plano.tipo_plano = e.target.value" v-model="plano.tipo_plano">
                  <option value="0">Pessoa física</option>
                  <option value="1">Pessoa jurídica</option>
                  <option value="2">Plano Familiar</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row" v-if="Number(plano.tipo_plano) === 0">
            <div class="col-md-4">
              <div class="form-group">
                <label>Preço <b>*Obrigatório</b></label>
                <money v-model="plano.price" v-bind="money" type="text" class="form-control">
                </money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Taxa adesão</label>
                <money v-model="plano.setup_fee" v-bind="money" type="text" class="form-control">
                </money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Uniodonto</label>
                <select
                  id="inputUniodonto"
                  v-model="plano.provider_id"
                  class="form-control"
                >
                  <option
                    v-for="(operadora,index) in operadoras"
                    :key="index"
                    :value="operadora.id"
                  >{{operadora.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Status do plano</label>
                <select class="form-control" @change="e => plano.active = e.target.value" v-model="plano.active">
                  <option value="1">Ativo</option>
                  <option value="0">Desativado</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Cartão de Crédito</label>
                <input v-model="plano.carencia" class="form-control" type="number"
                  placeholder="Informe o dia de carência. Ex: 10" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Boleto</label>
                <input v-model="plano.carencia_boleto" type="number" class="form-control"
                  placeholder="Informe o dia de carência. Ex: 10" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Quantidade Pessoas por Plano</label>
                <input v-model="plano.qtd_membros" type="number" class="form-control"
                  placeholder="Informe a quantidade de pessoas por plano. Ex: 6" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Quantidade Máxima de Pessoas por Plano</label>
                <input v-model="plano.qtd_max_membros" type="number" class="form-control"
                  placeholder="Informe a quantidade máxima de pessoas por plano. Ex: 6" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Preço por Boleto</label>
                <money v-model="plano.valor_boleto" v-bind="money" type="text" class="form-control">
                </money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Número do Plano</label>
                <input v-model="plano.plan_number" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Contrato</label>
                <input v-model="plano.contrato" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Acesso</label>
                <input v-model="plano.TokenAcesso" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Recorrente</label>
                <select v-model="plano.recorrencia" class="form-control">
                  <option value="1">Sim</option>
                  <option value="0">Não</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row" v-if="Number(plano.tipo_plano) === 2">
            <div class="col-md-12">
              <div class="form-group">
                <label>Uniodonto</label>
                <select
                  id="inputUniodonto"
                  v-model="plano.provider_id"
                  class="form-control"
                  @change="getPlanosFromUniodonto()"
                >
                  <option
                    v-for="(operadora,index) in operadoras"
                    :key="index"
                    :value="operadora.id"
                  >{{operadora.name}}</option>
                </select>
              </div>
            </div>
            
            <div
              class="row"
              v-for="(plan, index) in plano.planos_vinculados"
              :key="index"
              v-if="Number(plano.tipo_plano) === 2"
            >
              <div class="col-md-12 mt-4 mb-4 text-center">
                <h4>Plano Vinculado {{ index + 1 }}</h4>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Plano Base</label>
                  <select v-model="plan.plano_id" class="form-control" @change="getValoresDoPlano(plan)">
                    <option
                      v-for="pl in listaPlanos"
                      :key="pl.id"
                      :value="pl.id"
                    >
                      {{ pl.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Preço</label>
                  <money v-model="plan.price" v-bind="money" class="form-control"></money>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Taxa adesão</label>
                  <money v-model="plan.setup_fee" v-bind="money" class="form-control"></money>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Carência (Crédito)</label>
                  <input v-model="plan.carencia" type="number" class="form-control" />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>Qtd. Miníma</label>
                  <input v-model="plan.qtd_minima" type="number" class="form-control" />
                </div>
              </div>

              <div class="col-md-1 d-flex align-items-center mt-3">
                <button class="btn" @click="removePlanoVinculado(index)">
                  <i class="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="col-md-12 text-center mt-4">
              <button class="btn " @click="addPlanoVinculado">
                <i class="fa fa-plus"></i> Adicionar Plano Vinculado
              </button>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Número do Plano</label>
                <input v-model="plano.plan_number" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Contrato</label>
                <input v-model="plano.contrato" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Acesso</label>
                <input v-model="plano.TokenAcesso" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Recorrente</label>
                <select v-model="plano.recorrencia" class="form-control">
                  <option value="1">Sim</option>
                  <option value="0">Não</option>
                </select>
              </div>
            </div>
          </div>
          
          <div class="row" v-for="(plan, index) in plano.pessoa_juridica" :key="index" v-if="Number(plano.tipo_plano) === 1">
            <div class="col-md-12 mt-4 mb-4 text-center">
              <h4>Faixa {{ index + 1 }}</h4>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Preço <b>*Obrigatório</b></label>
                <money v-model="plan.price" v-bind="money" type="text" class="form-control"></money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Cartão de Crédito</label>
                <input v-model="plan.carencia" class="form-control" type="number"
                  placeholder="Informe o dia de carência. Ex: 10" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Taxa adesão</label>
                <money v-model="plan.setup_fee" v-bind="money" type="text" class="form-control"></money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Preço por Boleto</label>
                <money v-model="plan.valor_boleto" v-bind="money" type="text" class="form-control">
                </money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Número do Plano</label>
                <input v-model="plano.plan_number" type="number" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Contrato</label>
                <input v-model="plano.contrato" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Acesso</label>
                <input v-model="plano.TokenAcesso" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Boleto</label>
                <input v-model="plan.carencia_boleto" type="number" class="form-control"
                  placeholder="Informe o dia de carência. Ex: 10" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Qtd Participantes Min <b>*Obrigatório</b></label>
                <input type="number" class="form-control" placeholder="Min" v-model="plan.min">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Qtd Participantes Max <b>*Obrigatório</b></label>
                <input type="number" class="form-control" placeholder="Max" v-model="plan.max">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Status do plano</label>
                <select class="form-control" @change="e => plan.active = e.target.value" v-model="plan.active">
                  <option value="1">Ativo</option>
                  <option value="0">Desativado</option>
                </select>
              </div>
            </div>


            <div class="col-md-1 text-center text-md-left mb-3 mb-md-0 align-self-center mt-3">
              <div class="">

                <button v-if="index === plano.pessoa_juridica.length - 1" class="" @click="handleClickAddPlan">
                  <i class="fa fa-plus" style="font-size: 22px;"></i>
                </button>

                <button v-else class="" @click="handleClickRemovePlan(index)">
                  <i class="fa fa-minus" style="font-size: 22px;"></i>
                </button>
              </div>
            </div>         
          </div>

          <!-- <div v-if="Number(plano.tipo_plano) === 2"> -->
            <label>Atribuir desconto:</label>
            <div class="col-md-2">
              <div class="form-check d-flex flex-column">
                <input class="form-check-input" @change="plano.tipo_desconto='porcentagem'"  type="radio" name="exampleRadios" id="exampleRadios1" value="option1" :checked="plano.tipo_desconto=='porcentagem'">
                <label class="form-check-label" for="exampleRadios1">
                  Porcentagem
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" @change="plano.tipo_desconto='abs'" type="radio" name="exampleRadios" :checked="plano.tipo_desconto=='abs'" id="exampleRadios2" value="option2">
                <label class="form-check-label" for="exampleRadios2">
                  Valor Absoluto
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" @change="plano.tipo_desconto=null" type="radio" name="exampleRadios" :checked="plano.tipo_desconto==null" id="exampleRadios2" value="option3">
                <label class="form-check-label" for="exampleRadios2">
                  Nenhum
                </label>
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="plano.tipo_desconto == 'porcentagem'" class="form-group">
                <label>Porcentagem</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder
                  v-model="plano.valor_desconto"
                />
              </div>
              <div v-if="plano.tipo_desconto == 'abs'" class="form-group">
                <label>Valor Absoluto</label>
                <money  class="form-control" v-model="plano.valor_desconto" v-bind="money"></money> 
              </div>
            </div>   
          <!-- </div> -->

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Descrição Vendas <b>*Obrigatório</b></label>
                <vue-editor v-model="plano.descricao_vendas" :editorToolbar="customToolbar"></vue-editor>
              </div>

            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Cobertura <b>*Obrigatório</b></label>
                <vue-editor v-model="plano.cobertura" :editorToolbar="customToolbar"></vue-editor>
              </div>

            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label>Dúvidas Frequentes</label>
                <vue-editor v-model="plano.duvidas" :editorToolbar="customToolbar"></vue-editor>
              </div>

            </div>

          </div>

        </div>

        <!-- Card de abrangência -->
        <!-- <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Arquivos
            </h2>
            <p>Adicione ou remova arquivos na lista abaixo</p>
          </div>
          <div class="row" v-for="(qtd, index) in qtdArquivos" :key="index">
        
            <div class="col-md-3">
              <div class="form-group">
                <label>Arquivo</label>
                <input type="file" class="form-control"  id="file" ref="file" @change="upload_files">
              </div>
            </div>
            <div class="col-md-1">
              <button href="#0" class="btn_1 mt-4 mb-3" @click="qtdArquivos++">
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <hr>
            
          </div> 

                      
        </div>-->
        <p>
          <button href="#0" class="btn_1 medium pull-right mb-5 mr-4" @click="cria_plano">Criar Plano</button>
        </p>

        <!-- /container-fluid-->
      </div>


    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { Money } from 'v-money'
import { ReturnStringErrorByArrayOfErrors } from '../../../utils/util';

export default {
  components: {
    VueEditor,
    Money
  },
  data() {
    return {
      flagTrue: 1,
      flagFalse: 0,
      // qtdArquivos: 1,
      arquivos: [],
      operadoras: [],
      listaPlanos:[],
      nomeArquivo: '',
      file: '',
      plano: {
        name: "",
        price: "",
        setup_fee: "",
        provider_id: JSON.parse(localStorage.getItem("token_adm_comprodonto")).id_operadora,
        ans: "",
        length_interval: 1,
        unit_interval: "Monthly",
        tipo_plano: 0,
        active: 1,
        descricao_vendas: "",
        cobertura: "",
        qtd_membros: 1,
        qtd_max_membros: "",
        plan_number:'',
        contrato:'',
        TokenAcesso:'',
        recorrencia:'',
        pessoa_juridica: [{
          active: 0,
          price: "",
          min: "",
          max: ""
        }],
        planos_vinculados: [],
        tipo_desconto: "porcentagem",
        valor_desconto: ""
      },
      files: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      imagem_foto: "",
      mostraErro: false,
      isLoading: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
        //['image', 'code-block']
      ]
    };
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
      self.isLoading = true;
      ajax("get", "/operadoras")
        .then((response) => {
          self.isLoading = false;
          self.operadoras = response;
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
      ajax("get", `operadoras/${this.plano.provider_id}/planos`)
        .then((response) => {
          self.isLoading = false;
          self.listaPlanos = response.data;
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  },
  methods: {
    addPlanoVinculado() {
      this.plano.planos_vinculados.push({
        plano_id: "",
        price: "",
        setup_fee: "",
        carencia: "",
        carencia_boleto: "",
        qtd_minima: ""
      });
    },
    removePlanoVinculado(index) {
      this.plano.planos_vinculados.splice(index, 1);
    },
    getValoresDoPlano(plan) {
      const base = this.listaPlanos.find(p => p.id === plan.plano_id);
      if (base) {
        plan.price = (base.price/100) || "";
        plan.setup_fee = (base.setup_fee/100) || "";
        plan.carencia = base.carencia || "";
        plan.carencia_boleto = base.carencia_boleto || "";
      }
    },
    getPlanosFromUniodonto(){
      console.log(this.plano.provider_id);
        ajax("get", `operadoras/${this.plano.provider_id}/planos/adm`)
        .then((response) => {
          this.isLoading = false;
          this.listaPlanos = response.data;
        })
        .catch((error) => {
          this.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    emCentavos(valor) {
      if (!valor) return 0;
      
      return Math.round(valor * 100);
    },
    emReais(valor) {
      return valor ? (valor / 100).toFixed(2) : 0;
    },
    cria_plano() {
      var self = this;
      let valido = false;
      let erros = {};

      if(self.plano.qtd_membros==0){
        alert('A quantidade de membros deve ser maior que 0!');
        //self.isLoading = false;
        return;
      }

      if (Number(self.plano.tipo_plano) === 0) {
        if (self.plano.price && self.plano.cobertura && self.plano.name && self.plano.ans && self.plano.descricao_vendas) {
          self.plano.price = self.plano.price > 0 ? self.emCentavos(self.plano.price) : null;
          self.plano.setup_fee = self.emCentavos(self.plano.setup_fee);
          if (self.plano.valor_boleto > 0) {
            self.plano.valor_boleto = self.emCentavos(self.plano.valor_boleto)
          } else {
            self.plano.valor_boleto = null
          }

          valido = true
          delete self.plano.pessoa_juridica
        } else {
          erros = {};
          if (!self.plano.price) erros.price = ["O campo preço é obrigatório."];
        }

      } else if (Number(self.plano.tipo_plano) === 1) {
        valido = true
        self.plano.pessoa_juridica.forEach((item, index) => {

          if (!item.price || !item.min || !item.max) {
            valido = false;
            if (!item.price) {
              if (!erros.price) erros.price = [];
              erros.price.push(`O campo preço na Faixa ${index + 1} é obrigatório.`);
            }
            if (!item.min) {
              if (!erros.min) erros.min = [];
              erros.min.push(`O campo quantidade mínima na Faixa ${index + 1} é obrigatório.`);
            }
            if (!item.max) {
              if (!erros.max) erros.max = [];
              erros.max.push(`O campo quantidade máxima na Faixa ${index + 1} é obrigatório.`);
            }
          }
        });

        if (valido === true) {
          delete self.plano.price;
          delete self.plano.setup_fee;
          delete self.plano.carencia;
          delete self.plano.carencia_boleto;
          delete self.plano.qtd_membros;
          delete self.plano.valor_boleto;
          delete self.plano.active;
        }
      }else if (Number(self.plano.tipo_plano) === 2) {
        valido = true;

        if (!self.plano.planos_vinculados || self.plano.planos_vinculados.length === 0) {
          valido = false;
          erros.planos_vinculados = ["Adicione ao menos um plano vinculado."];
        } else {
          self.plano.planos_vinculados.forEach((p, index) => {
            if (!p.plano_id) {
              valido = false;
              if (!erros[`plano_${index}`]) erros[`plano_${index}`] = [];
              erros[`plano_${index}`].push(`Selecione o plano vinculado na linha ${index + 1}.`);
            }
          });
        }

        delete self.plano.pessoa_juridica;
        delete self.plano.carencia_boleto;
        delete self.plano.valor_boleto;
      }

      if (valido === true) {

        console.log(self.plano)
        var objRequest = new FormData();
        var item = self.plano;
        for (var key in item) {
          objRequest.append(key, item[key]);
        }

        var item = self.files;
        for (var key in item) {
          if (item[key]) objRequest.append(`files[${key}]`, item[key]);
        }

        if (Number(self.plano.tipo_plano) === 2 && self.plano.planos_vinculados.length > 0) {
          let precoTotal = 0;
          let setup_feeTotal = 0;
          let qtdMinTotal = 0;
          let maiorCarencia = 0;

          self.plano.planos_vinculados.forEach((plano, index) => {
            const preco = self.emCentavos(plano.price || 0);
            const setup = self.emCentavos(plano.setup_fee || 0);
            const qtdMin = Number(plano.qtd_minima) || 0;

            objRequest.append(`planos_vinculados[${index}][plano_familiar_id]`, plano.plano_id);
            objRequest.append(`planos_vinculados[${index}][price]`, preco);
            objRequest.append(`planos_vinculados[${index}][setup_fee]`, setup);
            objRequest.append(`planos_vinculados[${index}][carencia]`, plano.carencia || null);
            objRequest.append(`planos_vinculados[${index}][qtd_min]`, qtdMin);

            precoTotal += preco;
            setup_feeTotal += setup;
            qtdMinTotal += qtdMin;
            maiorCarencia = Math.max(maiorCarencia, plano.carencia || 0);
          });

          console.log(precoTotal, setup_feeTotal, qtdMinTotal);

          objRequest.append("price", precoTotal);
          objRequest.append("setup_fee", setup_feeTotal);
          objRequest.append("qtd_membros", qtdMinTotal);
          objRequest.append("carencia", maiorCarencia);
        }

        if(self.plano.tipo_desconto == 'abs') {
          objRequest.append("valor_desconto", self.emCentavos(self.plano.valor_desconto));
        }

        self.isLoading = true;
        ajax("post", "/planos_arquivos", objRequest)
          .then((response) => {
            self.isLoading = false;
            alerta(
              "success",
              "Criado",
              "Plano criado com sucesso!"
            );
            
            self.$router.replace(self.$route.query.redirect || "/adm/planos");
          })
          .catch((error) => {
            self.plano.price = self.emReais(self.plano.price);
            self.plano.valor_boleto = self.emReais(self.plano.valor_boleto);
            self.plano.setup_fee = self.emReais(self.plano.setup_fee);
            self.isLoading = false;
            tratamento_requisicao(error, this);
          });
      } else {

        if (!self.plano.name) erros.name = ["O campo nome é obrigatório."];
        if (!self.plano.ans) erros.ans = ["O campo ans é obrigatório."];
        if (!self.plano.descricao_vendas) erros.descricao_vendas = ["O campo descrição vendas é obrigatório."];
        if (!self.plano.cobertura) erros.cobertura = ["O campo cobertura é obrigatório."];
        console.log(erros);
        alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
      }
    },
    rmArquivo(idArquivo) {
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (user) {
        self.isLoading = true;
        this.$http
          .delete("arquivos/" + idArquivo)
          .then(res => res.json())
          .then(
            response => {
              self.isLoading = false;
              let index = self.arquivos.findIndex(x => x.id == idArquivo);
              self.arquivos.splice(index, 1);
            },
            err => {
              self.isLoading = false;
            }
          );
      } else {
        self.$router.replace(self.$route.query.redirect || "/");
      }
    },
    addArquivo() {
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (user) {
        self.isLoading = true;

        let formData = new FormData();
        formData.append('plan_id', self.id_plano);
        formData.append('file', self.file);
        formData.append('nome', self.nomeArquivo);

        self.$http
          .post("upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(res => res.json())
          .then(
            response => {
              self.isLoading = false;
              self.file = '';
              self.nomeArquivo = '';
              self.arquivos.push(response);
            },
            err => {
              self.isLoading = false;
            }
          );
      } else {
        self.$router.replace(self.$route.query.redirect || "/");
      }
    },
    handleFileUpload(e) {
      var files = e.target.files;
      this.file = files[0];
    },
    upload_files(event) {
      let self = this;
      self.files.push(event.target.files[0])
    },
    trocaFoto: function ($event) {
      this.plano.foto_plano = $event.target.files[0];
      this.imagem_foto = URL.createObjectURL(
        this.plano.foto_plano
      );
    }
  }
};
</script>